"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCheck = void 0;
var formCheck = {
  margin: {
    labelBottom: '0',
    inputLeft: '0',
    inputTop: '0',
    inputRight: '0.3125rem',
    inlineRight: '0.75rem'
  },
  padding: {
    inlineLeft: '0'
  }
};
exports.formCheck = formCheck;